export const SET_UP_TABLE = "SET_UP_TABLE";

export function set_up_table(props, selections) {
  let { tableKey, columns, showDetails, allowSelection, order } = props;

  if (!tableKey) alert("this table needs tableKey prop");

  return (dispatch) => {
    dispatch({
      type: SET_UP_TABLE,
      tableKey,
      columns,
      selections,
      order,
      showDetails: !!showDetails,
      allowSelection: !!allowSelection,
    });
  };
}

export const CHANGE_COLUMN_VISIBILITY = "CHANGE_COLUMN_VISIBILITY";

export function change_column_visibility(index, tableKey) {
  return (dispatch) => {
    dispatch({
      type: CHANGE_COLUMN_VISIBILITY,
      index,
      tableKey,
    });
  };
}

export const ORDER_BY_COLUMN = "ORDER_BY_COLUMN";

export function order(key, order, tableKey) {
  return (dispatch) => {
    dispatch({
      type: ORDER_BY_COLUMN,
      key,
      order,
      tableKey,
    });
  };
}

export const CHANGE_PAGE = "CHANGE_PAGE";

export function change_page(page, tableKey) {
  return (dispatch) => {
    dispatch({
      type: CHANGE_PAGE,
      page,
      tableKey,
    });
  };
}

export const CHANGE_PAGE_SIZE = "CHANGE_PAGE_SIZE";

export function change_page_size(size, tableKey) {
  return (dispatch) => {
    dispatch({
      type: CHANGE_PAGE_SIZE,
      size,
      tableKey,
    });
  };
}

export const SET_SELECTIONS = "SET_SELECTIONS";

export function change_selections(selections, tableKey) {
  return (dispatch) => {
    dispatch({
      type: SET_SELECTIONS,
      selections,
      tableKey,
    });
  };
}

export const SELECT_ITEM = "SELECT_ITEM";

export function select_item(key, isSelected, tableKey) {
  return (dispatch) => {
    dispatch({
      type: SELECT_ITEM,
      key,
      isSelected,
      tableKey,
    });
  };
}

export const CHANGE_FILTER_TYPE = "CHANGE_FILTER_TYPE";

export function change_filter_type(key, filterType, tableKey) {
  return (dispatch) => {
    dispatch({
      type: CHANGE_FILTER_TYPE,
      key,
      filterType,
      tableKey,
    });
  };
}

export const CHANGE_FILTER_VALUE = "CHANGE_FILTER_VALUE";

export function change_filter_value(key, tableKey, value) {
  return (dispatch) => {
    dispatch({
      type: CHANGE_FILTER_VALUE,
      key,
      tableKey,
      value,
    });
  };
}
